export default "__VITE_ASSET__CpCpP4qD__"